import type {
  FirmDocumentEditDialogProps,
  FirmDocumentReferenceObjectType,
  FirmDocumentReferenceWithRequestedFiles,
} from './FirmDocumentEditDialog.types';

export const LONG_FILE_EXTENSION_CHARACTER_COUNT = 5;

const getNormalizedReferenceObjectType = (
  referenceObjectType: string | undefined,
  referenceOptions: FirmDocumentEditDialogProps['referenceOptions']
) => {
  const normalizedReferenceObjectType = referenceObjectType?.trim().toLowerCase();

  if (!normalizedReferenceObjectType) {
    return null;
  }

  const matchingOption = referenceOptions.find(option => (
    option.value.trim().toLowerCase() === normalizedReferenceObjectType
      || option.label.trim().toLowerCase() === normalizedReferenceObjectType
  ));

  if (!matchingOption) {
    return null;
  }

  return matchingOption.value as FirmDocumentReferenceObjectType;
};

export const getInitialReferenceObjectTypes = (
  documentReference: FirmDocumentEditDialogProps['documentReference'],
  referenceOptions: FirmDocumentEditDialogProps['referenceOptions']
) => (
  documentReference?.referenced_in
    ?.map(reference => getNormalizedReferenceObjectType(reference.reference_object_type, referenceOptions))
    .filter((value): value is FirmDocumentReferenceObjectType => Boolean(value))
    ?? []
);

export const getInitialRequestedFileIds = (documentReference: FirmDocumentEditDialogProps['documentReference']) => (
  (documentReference as FirmDocumentReferenceWithRequestedFiles | null)?.requested_files
    ?.map(requestedFile => requestedFile.id)
    ?? []
);

export const getFileExtension = (documentReference: FirmDocumentEditDialogProps['documentReference']) => {
  const fileType = documentReference?.file.file_type;

  return fileType ? `.${fileType.toLowerCase()}` : '';
};

export const getEditableFileName = (documentReference: FirmDocumentEditDialogProps['documentReference']) => {
  if (!documentReference) {
    return '';
  }

  const fileExtension = getFileExtension(documentReference);
  const fileName = documentReference.file.filename;

  return fileExtension && fileName.toLowerCase().endsWith(fileExtension)
    ? fileName.slice(0, -fileExtension.length)
    : fileName;
};
